import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyWhoIsOnCall: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-who-is-on-call", jiraSpaEntry: "async-jira-eoc-who-is-on-call" */ '@jira/eoc__who-is-on-call/src/ui/index.tsx'
		),
);

export const WhoIsOnCallComponent = (): React.JSX.Element => (
	<LazyPage
		Page={LazyWhoIsOnCall}
		pageId="async-jira-eoc-who-is-on-call"
		shouldShowSpinner={false}
	/>
);
